// extracted by mini-css-extract-plugin
export var header = "styles-module--header--kI6Qz";
export var left = "styles-module--left--ULCMM";
export var closeBtn = "styles-module--closeBtn--ByeeE";